import { Link } from 'react-router-dom';
import { siteBrand, siteSlogan } from '@/mocks/manga';

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20fashionable%20young%20gal%20with%20flowing%20coral%20pink%20dyed%20hair%20in%20casual%20street%20style%20clothes%2C%20confident%20playful%20pose%2C%20warm%20coral%20red%20and%20amber%20orange%20gradient%20background%20with%20soft%20glowing%20bokeh%20and%20tiny%20sparkles%2C%20clean%20modern%20manga%20art%20style%2C%20high%20energy%20youthful%20mood%2C%20lots%20of%20empty%20space%20around%20the%20character&width=1600&height=900&seq=hero-gal-2026&orientation=landscape"
        alt="泡在我家的辣妹漫画中的元气辣妹女主角插画"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/45 to-foreground-950/70"></div>

      <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center px-4 py-24 text-center md:py-32">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur">
          <i className="ri-heart-3-line text-primary-300"></i>
          校园恋爱喜剧 · 同居日常
        </span>
        <h1 className="mt-6 max-w-3xl text-3xl leading-snug text-background-50 md:text-5xl md:leading-tight">
          {siteBrand}
          <span className="mt-1 block font-sans text-base font-normal text-background-200 md:text-xl">
            辣妹住进家里之后，故事才真正开始
          </span>
        </h1>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
          {siteSlogan}。这里为你梳理故事主线、人物设定与分集剧情，看懂每一个名场面背后的来龙去脉。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/plot"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-400"
          >
            先看剧情主线
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/episodes"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
          >
            分集剧情速览
          </Link>
        </div>
      </div>
    </section>
  );
}